"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyFeaturedContentV3GetOne = void 0;
exports.featuredContentV3GetOneSetMock = featuredContentV3GetOneSetMock;
exports.featuredContentV3GetOne = featuredContentV3GetOne;
exports.useQueryFeaturedContentV3GetOne = useQueryFeaturedContentV3GetOne;
exports.useInfiniteQueryFeaturedContentV3GetOne = useInfiniteQueryFeaturedContentV3GetOne;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function featuredContentV3GetOneSetMock(mock) {
    setMock = mock;
}
async function featuredContentV3GetOne(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-athenaeum-service/v3/featured-content/${params.id}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfAthenaeumServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyFeaturedContentV3GetOne = 'wolf-athenaeum-service:featuredContentV3GetOne:get';
function useQueryFeaturedContentV3GetOne(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyFeaturedContentV3GetOne, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryFeaturedContentV3GetOne(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyFeaturedContentV3GetOne, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = featuredContentV3GetOne(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=featured-content-v3-get-one.js.map